import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
	selector: 'sgp-nenhum-resultado',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './nenhum-resultado.component.html'
})
export class NenhumResultadoComponent {
	@Input() exibir = false;
}
